export default __webpack_public_path__ + "static/media/20.d1f79459.jpeg";